import { Link } from 'react-router-dom'
import React, { forwardRef, memo } from 'react'

import { ButtonStyled } from './Button.styles'
import ButtonContent from './ButtonContent'

import { ButtonProps } from './index'

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      size = 'def',
      color = 'primary',
      isLoading = false,
      disabled,
      href,

      children,
      text,
      iconStart,
      iconEnd,
      ...rest
    },
    ref,
  ) => {
    return (
      <ButtonStyled
        ref={ref}
        $isLoading={isLoading}
        disabled={isLoading || disabled}
        $size={size}
        $color={color}
        // @ts-ignore
        href={href ? href.toString() : undefined}
        to={href}
        LinkComponent={Link}
        {...rest}
      >
        <ButtonContent text={text} isLoading={isLoading} iconStart={iconStart} iconEnd={iconEnd}>
          {children}
        </ButtonContent>
      </ButtonStyled>
    )
  },
)

export default memo(Button)
